/**
 * Function to validate email id
 * @param {String} email 
 * @returns Boolean
 */
const validate_email = ( email ) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email)?.toLowerCase());
};

/**
 * Function to disable the form when it is being processed
 * @param {Event} event 
 */
const disable_form = ( event ) => {
	// Disable all input fields on submit
	event.target.querySelectorAll('input, button, textarea').forEach( (element) => {
    element.setAttribute( 'disabled', '' );
  } );

	// Hide the normal button submission text
  event.target.querySelectorAll('.contact-form-btn-text').forEach( (element) => {
    element.classList.add('d-none');
  } );

	// Show the form processing text
  event.target.querySelectorAll('.contact-form-processing-text').forEach( (element) => {
    element.classList.remove('d-none');
  } );
};

/**
 * Function to enable the form for resubmitting
 * @param {Node} form_elem 
 */
const enable_form = ( form_elem ) => {
	form_elem.reset();

  // Remove the disabled attribute from the input items and button
  form_elem.querySelectorAll('input, button, textarea').forEach( (element) => {
    element.removeAttribute( 'disabled' );
  } );

  // Change the submit button text to normal text
  form_elem.querySelectorAll('.contact-form-btn-text').forEach( (element) => {
    element.classList.remove('d-none');
  } );

  // Hide the button processing text
  form_elem.querySelectorAll('.contact-form-processing-text').forEach( (element) => {
    element.classList.add('d-none');
  } );
};

// Listen to form submit and handle it accordingly
document.getElementById('contact_form').addEventListener( 'submit', async (e) => {
	e.preventDefault();

	// Get all the form data
	const contact_form_data = new FormData( e.target );

	const contact_form_data_obj = {
		first_name: contact_form_data.get( 'first_name' ),
		last_name: contact_form_data.get( 'last_name' ),
		email_id: contact_form_data.get( 'email' ),
		phone_no: ( contact_form_data.get( 'phone_no' ) === '' ) ? 'Not Provided' : contact_form_data.get( 'phone_no' ),
		subject: contact_form_data.get( 'subject' ),
		message: contact_form_data.get( 'message' ),
		turnstile_token: contact_form_data.get( 'cf-turnstile-response' ),
		turnstile_connecting_ip: contact_form_data.get( 'CF-Connecting-IP' ),
	}

	// Validate the fields
	if( !validate_email( contact_form_data_obj.email_id ) ) {
		alert( `Sorry! ${contact_form_data_obj.email_id} is not a valid email. Please provide a valid email address with a correct domain name.` )
	}

	// Disable the form fields
	disable_form( e );

	// First, we need to send an API request to validate the Turnstile server-side authentication
	let turnstile_auth_resp;
	try {
		// Send the API request to authenticate Turnstile at the server side
		const turnstile_auth_req = await fetch( 'https://api.isaumya.com/turnstile-auth', {
			method: 'POST',
			cache: 'no-cache',
			headers: {
				'content-type': 'application/json'
			},
			body: JSON.stringify( {
				turnstile_token: contact_form_data_obj.turnstile_token,
				turnstile_connecting_ip: contact_form_data_obj.turnstile_connecting_ip
			} )
		} );

		// Get the response from the API
		turnstile_auth_resp = await turnstile_auth_req.json();
	} catch (err) {
		console.error( 'Something went wrong when sending Turnstile API request', err );
	}

	// Check if we got a successful response
	if( turnstile_auth_resp.success ) {
		// Now we can go ahead and send the API request for sending the email via SendInBlue
		let send_mail_api_resp;

		try {
			const send_mail_api_req = await fetch( 'https://api.isaumya.com/send-mail', {
				method: 'POST',
				cache: 'no-cache',
				headers: {
					'content-type': 'application/json'
				},
				body: JSON.stringify( {
					first_name: contact_form_data_obj.first_name,
					last_name: contact_form_data_obj.last_name,
					email_id: contact_form_data_obj.email_id,
					phone_no: contact_form_data_obj.phone_no,
					subject: contact_form_data_obj.subject,
					message: contact_form_data_obj.message
				} )
			} );

			// Get the response from the API
			send_mail_api_resp = await send_mail_api_req.json();
		} catch (err) {
			console.error( 'Something went wrong when sending send mail API request', err );
		}

		if( send_mail_api_resp.success ) {
			// Show the success message
			document.getElementById('success_alert').classList.remove( 'd-none' );

			// Reset and enable the form now
			enable_form( e.target );
		} else {
			console.error( 'Something went wrong when sending send mail API request', send_mail_api_resp );
		}
	} else {
		console.error( 'Something went wrong when sending Turnstile API request', turnstile_auth_resp );
	}
} );